export const getFilename = (url: string) => {
    const imageUrl = new URL(url)
    const fileName = imageUrl.pathname.split('/').pop()
    return fileName
}
